import styled from 'styled-components';

const Text = styled.div`
  width: 100%;
  font-size: 16px;
`;

export default Text;
